module.exports = __webpack_public_path__ + "img/chacuo.860c1b7e.png";